<template>
	<v-simple-table>
		<tr v-for="(prop, key) in currentProperties" :key="key">
			<td style="width: 150px">
				<label :for="prop.key">
					{{ capitalize(prop.key) }}
				</label>
			</td>
			<td colspan="2">
				<input
					v-if="advancedEdit"
					:id="prop.key"
					v-model="prop.value"
					:name="prop.key"
					:disabled="prop.key === 'password'"
					@input="update(prop)"
				/>
				<span v-else class="prop-value-text">{{ prop.value }}</span>
			</td>
		</tr>
		<tr v-for="(prop, i) in newProperties" :key="'n' + i">
			<td>
				<select
					v-model="prop.key"
					@input="handleChangeNewPropKey(i, $event.target.value)"
				>
					<option
						v-for="key in currentWhitelist(prop.key)"
						:key="key"
						:value="key"
						v-text="capitalize(key) || '---'"
					/>
				</select>
			</td>
			<td>
				<input v-model="prop.value" @input="update(prop)" />
			</td>
			<td class="px-0" style="width: 24px">
				<v-btn small icon @click="removeNewProperty(i)"
					><v-icon small>fa-minus</v-icon></v-btn
				>
			</td>
		</tr>
		<tr v-if="advancedEdit">
			<td colspan="2">
				<v-btn small :disabled="disableAddNewProp" @click="addNewProperty">
					<v-icon color="ocean" small left>fa-plus</v-icon>
					Add new property
				</v-btn>
			</td>
		</tr>
	</v-simple-table>
</template>

<style scoped>
input,
select {
	border-bottom: 1px solid rgba(0, 0, 0, 0.67);
	padding: 2px 4px;
	width: 100%;
	outline: none;
}
select {
	border-left: 1px solid rgba(0, 0, 0, 0.67);
}
.prop-value-text {
	padding: 2px 4px;
}
</style>

<script>
import _ from "lodash";

import { mapGetters, mapMutations } from "vuex";

import config from "@/../public/config.json";

export default {
	data() {
		return {
			currentProperties: [],
			newProperties: [],
		};
	},

	computed: {
		...mapGetters("userEdit", [
			"advancedEdit",
			"properties",
			"updatedProperties",
		]),

		userProperties() {
			const properties = Object.entries(this.properties)
				.map(([key, value]) => ({ key, value }))
				.sort();
			return properties;
		},

		disableAddNewProp() {
			return !this.whitelist.length || this.newProperties.some(e => !e.key);
		},

		whitelist() {
			const allPropKeys = [
				...this.currentProperties,
				...this.newProperties,
			].map(e => e.key);

			return _.difference(config.propertiesWhitelist, allPropKeys);
		},
	},

	watch: {
		userProperties: {
			deep: true,
			handler(props) {
				this.currentProperties = [...props];
			},
		},

		advancedEdit(val) {
			if (!val) {
				this.newProperties = [];
				this.currentProperties = this.userProperties.map(props => ({ ...props }));
			}
		},
	},

	created() {
		this.currentProperties = this.userProperties.map(props => ({ ...props }));
	},

	methods: {
		...mapMutations("userEdit", {
			updateProp: "SET_UPDATED_SSO_PROPERTY",
			deleteProp: "DEL_UPDATED_SSO_PROPERTY",
		}),

		capitalize(str) {
			return _.startCase(str);
		},

		currentWhitelist(key) {
			return [key, ...this.whitelist];
		},

		addNewProperty() {
			this.newProperties.push({});
		},

		removeNewProperty(index) {
			this.deleteProp(this.newProperties[index].key);
			this.newProperties.splice(index, 1);
		},

		update({ key, value }) {
			this.updateProp([key, value]);
		},

		handleChangeNewPropKey(index, key) {
			const currentProp = this.newProperties[index];
			if (currentProp.key) {
				// remove key from vuex
				this.deleteProp(currentProp.key);
			}
			// update new key with old value
			this.update({
				key,
				value: currentProp.value,
			});
		},
	},
};
</script>
